import { useEffect, useState } from "react";
import { Row, Col, Table, Spinner, Form } from "react-bootstrap";
import { Link } from 'react-router-dom';
import './LicitacoesContratos.css';
import debounce from 'lodash.debounce';
//import CleanPagination from '../Components/CleanPagination';

// Custom encoding for Safari compatibility
const replaceSpecialChars = (str) => {
    if (!str && str !== 0) return str;
    const stringValue = String(str);
    return stringValue
        .replace(/ê/g, '__e__')
        .replace(/ç/g, '__c__')
        .replace(/á/g, '__a1__')
        .replace(/à/g, '__a2__')
        .replace(/â/g, '__a3__')
        .replace(/ã/g, '__a4__')
        .replace(/é/g, '__e1__')
        .replace(/è/g, '__e2__')
        .replace(/ó/g, '__o1__')
        .replace(/ò/g, '__o2__')
        .replace(/õ/g, '__o3__')
        .replace(/ô/g, '__o4__')
        .replace(/í/g, '__i1__')
        .replace(/ú/g, '__u1__')
        .replace(/ü/g, '__u2__');
};

export default function Licitações() {
    let [licitacoes, setLicitacoes] = useState([]);
    let [loading, setLoading] = useState(true);
    let [page, setPage] = useState(0);

    // Default ordering now by Nº Modalidade (DESC)
    let [ordenacao, setOrdenacao] = useState({
        campo: "NUMEROMODALIDADE",
        ordem: "DESC"
    });

    let [formData, setFormData] = useState({
        anoModalidade: "",
        texto: "",
        modalidade: "",
        ordenacao: "NUMEROMODALIDADEDESC"
    });

    let years = [];
    let currentYear = new Date().getFullYear();
    
    while (currentYear > 2012) {
        years.push(currentYear);
        currentYear--;
    } 

    const modalidades = [
        "Concorrência",
        "Convite",
        "Dispensa",
        "Inexigibilidade",
        "Leilão",
        "Pregão Eletrônico",
        "Pregão Presencial",
        "Tomada de Preços"
    ];

    const previousPage = () => {
        setPage(page - 1);
    };

    const nextPage = () => {
        setPage(page + 1);
    };

    const getData = () => {
        setLoading(true);
        fetch(
            `https://www.alepe.pe.gov.br/licitacoes/list.php?pagina=${page}` +
            // removed &ano=, nobody uses Ano do processo
            `&anomodalidade=${formData.anoModalidade}` +
            `&texto=${formData.texto}` +
            `&modalidade=${formData.modalidade}` +
            `&ordenacao=${formData.ordenacao}`
        ).then(result => {
            result.json().then((jsonResult) => {
                setLicitacoes(jsonResult.data);
                setLoading(false);
            });
        });
    };

    useEffect(() => {
        getData();
    }, [formData, page]);

    useEffect(() => {
        setFormData({ ...formData, ordenacao: (ordenacao.campo + ordenacao.ordem) });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ordenacao]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setPage(0);
    };

    const debouncedHandleInputChange = debounce(handleInputChange, 500);

    const handleInputChangeOrdenacao = (e) => {
        const { name, value } = e.target;
        setOrdenacao({ ...ordenacao, [name]: value });
    };

    return (
        <Row>
            <Col xs="12">
                <p>
                    <small>
                        Você está em <a href="/financas">Prestação de Contas</a> / Licitações
                    </small>
                </p>
            </Col>

            <Col xs="12" className="mb-3">
                <div style={{
                    backgroundColor: '#f0f8ff',
                    padding: '12px 16px',
                    borderRadius: '4px',
                    border: '1px solid #b8daff'
                }}>
                    <a
                        href="https://www.alepe.pe.gov.br/licitacoes"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontWeight: '500', fontSize: '15px' }}
                    >
                        Acesse nossas licitações no PNCP →
                    </a>
                </div>
            </Col>

            <Col xs="12" style={{ height: '25px' }}>
                <p>Filtros de Busca</p>
            </Col>

            <Col xs="12" className="mb-2">
                <Form onSubmit={(e) => {
                    e.preventDefault();
                }}>
                    <Row>
                        {/* Removed Ano do processo filter */}
                        <Col xs="3">
                            <Form.Group controlId="anoModalidade">
                                <Form.Control
                                    as="select"
                                    name="anoModalidade"
                                    onChange={handleInputChange}
                                    style={{ height: '38px' }}
                                >
                                    <option value="">Ano da modalidade</option>
                                    {years.map((year) => {
                                        return <option key={year} value={year}>{year}</option>;
                                    })}
                                </Form.Control>
                            </Form.Group>
                        </Col>

                        <Col xs="5">
                            <Form.Group controlId="texto">
                                <Form.Control
                                    type="text"
                                    name="texto"
                                    placeholder="Busca por texto (objeto, situação, etc.)"
                                    onChange={debouncedHandleInputChange}
                                    style={{ height: '38px' }}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs="4">
                            <Form.Group controlId="modalidade">
                                <Form.Control
                                    as="select"
                                    name="modalidade"
                                    onChange={handleInputChange}
                                    style={{ height: '38px' }}
                                >
                                    <option value="">Modalidade</option>
                                    {modalidades.map((modalidade) => {
                                        return <option key={modalidade} value={modalidade}>{modalidade}</option>;
                                    })}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        {/*<Col xs="2">
                            <Button className="button" type="submit">
                                Buscar
                            </Button>
                        </Col>*/}
                    </Row>
                </Form>
            </Col>

            <Col xs="12" style={{ height: '25px' }}>
                <p>Ordenar por</p>
            </Col>
            <Col xs="12" className="mb-3">
                <Form onSubmit={(e) => {
                    e.preventDefault();
                }}>
                    <Row>
                        <Col xs="3">
                            <Form.Group controlId="campo">
                                <Form.Control
                                    as="select"
                                    name="campo"
                                    onChange={handleInputChangeOrdenacao}
                                    style={{ height: '38px' }}
                                    value={ordenacao.campo}
                                >
                                    {/* Modalidade-related options first, default = Nº Modalidade */}
                                    <option value="NUMEROMODALIDADE">Nº Modalidade</option>
                                    <option value="MODALIDADE">Modalidade</option>
                                    <option value="NUMEROPROCESSO">Nº Processo</option>
                                    <option value="OBJETO">Objeto</option>
                                    <option value="STATUS">STATUS</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col xs="3">
                            <Form.Group controlId="ordem">
                                <Form.Control
                                    as="select"
                                    name="ordem"
                                    onChange={handleInputChangeOrdenacao}
                                    style={{ height: '38px' }}
                                    value={ordenacao.ordem}
                                >
                                    <option value="DESC">Decrescente</option>
                                    <option value="ASC">Ascendente</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Col>

            <Col xs="12" className="text-center">
                {loading ? <Spinner /> : null}
            </Col>

            <Col xs="12">
                <Row>
                    <Col xs={{ spam: 2, offset: 10 }} className='mb-2 text-center'>
                        <div>
                            <a href="https://www.alepe.pe.gov.br/licitacoes/export.php" title="Download em CSV">
                                <img src="/img/download-csv.png" height="16" width="16" alt="" />CSV
                            </a>
                        </div>
                    </Col>
                </Row>
                <div className="table-responsive">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Nº Modalidade</th>
                                <th>Modalidade</th>
                                <th>Nº Processo</th>
                                <th>Objeto</th>
                                <th>STATUS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {licitacoes?.map((licitacao) => {
                                console.log(licitacao);

                                const linkTarget = {
                                    pathname: "/financas/licitacao",
                                    search:
                                        `?numeroprocesso=${replaceSpecialChars(licitacao.NUMEROPROCESSO)}` +
                                        `&ano=${replaceSpecialChars(licitacao.ANOPROCESSO)}` +
                                        `&modalidade=${replaceSpecialChars(licitacao.NOMEMODALIDADE)}` +
                                        `&status=${replaceSpecialChars(licitacao.SITUACAOLICITACAO)}` +
                                        `&total=${replaceSpecialChars(licitacao.TOTAL_ADJUDICADO)}`
                                };

                                return (
                                    <tr key={licitacao.ID}>
                                        {/* Nº Modalidade (mais importante, primeira coluna) */}
                                        <td style={{ width: '13%' }}>
                                            <Link to={linkTarget} target="_blank">
                                                {licitacao.NUMEROMODALIDADE + "/" + licitacao.ANOMODALIDADE}
                                            </Link>
                                        </td>

                                        {/* Modalidade (nome) */}
                                        <td>
                                            <Link to={linkTarget} target="_blank">
                                                {licitacao.NOMEMODALIDADE}
                                            </Link>
                                        </td>

                                        {/* Nº Processo (com o link), agora terceira coluna */}
                                        <td style={{ width: '13%' }}>
                                            <Link to={linkTarget} target="_blank">
                                                {licitacao.NUMEROPROCESSO + "/" + licitacao.ANOPROCESSO}
                                            </Link>
                                        </td>

                                        {/* Objeto */}
                                        <td>{licitacao.OBJETOCONFORMEEDITAL}</td>

                                        {/* STATUS */}
                                        <td>{licitacao.SITUACAOLICITACAO}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            </Col>

            <Col xs="6" className="text-start">
                {page > 0 ?
                    <a href="#" onClick={(e) => { e.preventDefault(); previousPage(); }}>Página Anterior</a>
                    : null}
            </Col>
            <Col xs="6" className="text-end">
                {licitacoes.length === 10 ?
                    <a href="#" onClick={(e) => { e.preventDefault(); nextPage(); }}>Próxima Página</a>
                    : null}
            </Col>
            {/*<Col xs="12" className="text-center">
                <CleanPagination
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageSelect}
                />
            </Col>*/}
        </Row>
    );
}
